// @ts-nocheck
import { css } from "styled-components";

type Spacing = string | 0 | null;
type Property = "margin" | "padding";

const _spacingStyles = (
    top?: Spacing,
    right?: Spacing,
    bottom?: Spacing,
    left?: Spacing,
    property: Property = "margin",
    override?: boolean,
) => {
    return css`
        ${top !== null
            ? `${property}-top: ${top}; ${top !== 0 ? `&:first-child { ${property}-top: ${override ? top : 0}; }` : ""}`
            : ""}
        ${right !== null
            ? `${property}-right: ${right}; ${
                  right !== 0 ? `&:last-child { ${property}-right: ${override ? right : 0}; }` : ""
              }`
            : ""}
        ${bottom !== null
            ? `${property}-bottom: ${bottom}; ${
                  bottom !== 0 ? `&:last-child { ${property}-bottom: ${override ? bottom : 0}; }` : ""
              }`
            : ""}
        ${left !== null
            ? `${property}-left: ${left}; ${
                  left !== 0 ? `&:first-child { ${property}-left: ${override ? left : 0}; }` : ""
              }`
            : ""}
    `;
};

export const contentSpacingStyles = (
    top?: Spacing,
    right?: Spacing,
    bottom?: Spacing,
    left?: Spacing,
    property: Property = "margin",
) => {
    return _spacingStyles(top, right, bottom, left, property, false);
};

export const widgetWrapperStyles = () => {
    return css`
        ${contentSpacingStyles()}
    `;
};
